export default {
  getProgressAnalysis: (state) => state.progressanalysis,
};
